import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../../contexts/DataContext";
import Panel from "../UI/Panel/Panel";
import PanelContent from "../UI/Panel/PanelContent";
import PanelTitle from "../UI/Panel/PanelTitle";
import styled from "styled-components";
import EventEditor from "../Modals/EventEditor";
import { Button } from "../../Theme/Hyper";
import GroupEditor from "../Modals/GroupEditor";
import { UIContext } from "../../contexts/UIContext";
const PlayerSpan = styled.span`
  background-color: #ffffff;
  margin-right: 4px;
  padding: 4px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  > tbody > tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }

  th {
    padding: 10px;
    border-top: 1px solid #dee2e6;
  }
  td {
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    width: ${(props) => props.width};
    padding: 8px;
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.8em;
  }
  > tbody > tr:hover {
    background-color: #14ec8e;
    color: white;
    cursor: pointer;
  ${PlayerSpan} {
    color: #868ba1;
    cursor: pointer;
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #343a40;
  text-align: left;
`;

export default function Groups() {
  const { getGroup } = useContext(DataContext);
  const [groups, setGroups] = useState();
  const [selectedGroup, setSelectedGroup] = useState();
  const { selectedCompetition } = useContext(UIContext);
  useEffect(() => {
    getData();
  }, [selectedCompetition]);

  function getData() {
    getGroup().then((data) => {
      setGroups(
        [...(data || [])]
          .filter((g) => g.competition?._id === selectedCompetition?._id)
          .sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          })
      );
    });
  }
  return (
    <>
      <Button
        green
        style={{ margin: "1em", width: "200px" }}
        onClick={() => {
          setSelectedGroup({ competition: selectedCompetition._id });
        }}
      >
        + Create Group
      </Button>
      <Panel style={{ marginTop: "1em" }}>
        <PanelTitle title={"Group List"} />
        <PanelContent>
          <Table>
            <thead>
              <tr>
                <TH>ID</TH>
                <TH>Name</TH>
                <TH>Players</TH>
              </tr>
            </thead>
            <tbody>
              {groups &&
                groups.map((group) => {
                  return (
                    <tr
                      onClick={() => {
                        setSelectedGroup(group);
                      }}
                    >
                      <td>{group._id}</td>
                      <td>{group.name}</td>
                      <td>
                        {group.players?.map((p) => {
                          return (
                            <PlayerSpan>
                              {p?.first_name} {p?.last_name}
                            </PlayerSpan>
                          );
                        })}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </PanelContent>
      </Panel>
      {selectedGroup && (
        <GroupEditor
          group={selectedGroup}
          selectGroup={(s) => {
            setSelectedGroup(s);
          }}
          onCancel={() => {
            setSelectedGroup();
          }}
          onSave={() => {
            setSelectedGroup();
            getData();
          }}
        />
      )}
    </>
  );
}
